<template>
  <div>
    <table-view
      ref="tableList"
      :isSearchLoading="isAllLoad"
      :searchModel="searchModel"
      :tableModel="tableModel"
      @pageChange="params => _getTableData(params)"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      tableCardTitle="BLACK LIST"
    >
      <template v-slot:name="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.name }}
        </a>
      </template>
      <template v-slot:action="{ tableRow }">
        <el-popconfirm
          title="Confirm to remove？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveBlackList(tableRow.row)"
        >
          <a href="javascript:void(0)" slot="reference">Remove Blacklist</a>
        </el-popconfirm>
      </template>
      <template v-slot:btnArr>
        <customize-button type="primary" @click="handleDownload">
          Download
        </customize-button>
      </template>
    </table-view>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
import { getTableData, removeBlackList, getAddlog } from './api'
import { download } from './api'

const selectList = ['Country', 'Region', 'CCA', 'Business', 'Geo']

export default {
  data() {
    const searchModel = [
      {
        label: 'Customer #',
        type: 'input',
        key: 'code',
      },
      {
        label: 'Customer Name',
        type: 'input',
        key: 'name',
      },
      {
        label: 'Business',
        type: 'select',
        key: 'business',
        selectList: [],
      },
      // {
      //   label: 'Credit Analyst',
      //   type: 'input',
      //   key: 'creditManager',
      // },
      {
        label: 'GEO',
        type: 'select',
        key: 'geo',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'Region',
        type: 'select',
        key: 'region',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'Country',
        type: 'select',
        key: 'country',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'State',
        type: 'input',
        key: 'state',
      },
      {
        label: 'City',
        type: 'input',
        key: 'city',
      },
      {
        label: 'CCA',
        type: 'select',
        key: 'cca',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'Business Entity',
        type: 'select',
        key: 'businessEntity',
        placeholder: 'All',
        selectList: [
          { id: 1, name: 'Parent' },
          { id: 2, name: 'Subsidiary' },
        ],
      },
      {
        label: 'Account Status',
        type: 'select',
        key: 'accountStatus',
        placeholder: 'All',
        selectList: [
          { id: 1, name: 'Active' },
          { id: 2, name: 'High Risk' },
          { id: 3, name: 'Inactive' },
          { id: 4, name: 'On Hold' },
        ],
      },
      // {
      //   label: 'Source',
      //   type: 'select',
      //   key: 'source',
      //   placeholder: 'All',
      //   selectList: [
      //     { id: 1, name: 'Lenovo' },
      //     { id: 2, name: 'CSS' },
      //   ],
      // },
    ]
    const tableModel = [
      {
        label: 'Customer Name',
        slotName: 'name',
      },
      {
        label: 'Customer #',
        prop: 'code',
      },
      // {
      //   label: 'Credit Analyst',
      //   prop: 'creditManager',
      // },
      {
        label: 'Adverse Business Status',
        prop: 'businessStatusStr',
        width: '200px',
      },
      {
        label: 'City',
        prop: 'city',
      },
      {
        label: 'Country',
        prop: 'country',
      },
      {
        label: 'Add Time',
        prop: 'blackListDate',
      },
      {
        label: 'Comments',
        prop: 'blackListReason',
      },
      {
        label: 'GEO',
        prop: 'geo',
        width: '100px',
      },
      {
        label: 'Source',
        prop: 'sourceStr',
      },
      {
        label: 'Action',
        slotName: 'action',
      },
    ]
    return {
      searchModel: searchModel,
      tableModel: tableModel,
      isAllLoad: true,
      tableData: [],
      pages: {},
    }
  },
  created() {
    this.getAllSelect()
  },
  mounted() {
    this.initTable()
  },
  methods: {
    async handleDownload() {
      try {
        const params = this.$refs.tableList.getSearchData()
        await download(params)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async handleHrefInfoPage({
      id,
      name,
      address,
      country,
      code,
      city,
      state,
    }) {
      await this.$storage.setItem('customerId', id)
      await this.$storage.setItem('customerInfo', {
        name,
        address,
        country,
        code,
        city,
        state,
      })
      this.$router.push(`/customer-management/${id}/info/snapshot`)
      const params = {
        companyId: id,
      }
      await getAddlog(params)
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [countryList, regionList, ccaList, businessList, geoList] =
              res
            for (let i = 0; i < this.searchModel.length; i++) {
              const item = this.searchModel[i]

              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.error(`search 列表查询错误:${err}`)
        })
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    async handleRemoveBlackList({ id }) {
      try {
        await removeBlackList(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="less"></style>
